import {FC, useCallback, useEffect, useState} from 'react'
import {Modal} from 'react-bootstrap'
import {useNavigate} from 'react-router-dom'
import Button from '../Button'
import clsx from 'clsx'

type okBtnProps = {
  title: string
  className?: string
}

type cancelBtnProps = {
  title: string
  className?: string
}

type Props = {
  when: boolean
  onOK: () => any
  onCancel?: () => any
  onOkBtn?: okBtnProps
  onCancelBtn?: cancelBtnProps
  content?: {
    header?: string
    body?: string | any
  }
  centered?: boolean
  swapBtn?: boolean
}

const Prompt: FC<Props> = (props) => {
  const {when, onOK, onCancel, content, onOkBtn, onCancelBtn, centered, swapBtn} = props

  const history = useNavigate()

  const [showPrompt, setShowPrompt] = useState(false)
  const [currentPath, setCurrentPath] = useState('')
  const [isSubmitting, setIsSubmitting] = useState(false)

  useEffect(() => {
    // if (when) {
    //   history.block((prompt) => {
    //     setCurrentPath(prompt.pathname)
    //     setShowPrompt(true)
    //     return 'true'
    //   })
    // } else {
    //   history.block(() => {})
    // }
    // return () => {
    //   history.block(() => {})
    // }
  }, [history, when])

  const handleOK = useCallback(async () => {
    // if (onOK) {
    //   setIsSubmitting(true)
    //   const canRoute = await Promise.resolve(onOK())
    //   if (canRoute) {
    //     history.block(() => {})
    //     history(currentPath)
    //   }
    //   setIsSubmitting(false)
    // }
  }, [currentPath, history, onOK])

  const handleCancel = useCallback(async () => {
    if (onCancel) {
      // const canRoute = await Promise.resolve(onCancel())
      // if (canRoute) {
      //   history.block(() => {})
      //   history(currentPath)
      // }
    }
    setShowPrompt(false)
  }, [currentPath, history, onCancel])

  return showPrompt ? (
    <Modal show={showPrompt} dialogClassName='h-auto' onHide={handleCancel} centered={centered}>
      <div className='modal-header d-flex'>
        <h5 className='modal-title'>
          {content && content.header ? content.header : 'Unsaved changes'}
        </h5>
      </div>
      <div className='modal-body align-items-center'>
        {content && content.body
          ? content.body
          : 'There are unsaved changes. Are you sure want to leave this page ?'}
      </div>
      <div className='modal-footer'>
        <div className={clsx('d-flex justify-content-end gap-5', swapBtn && 'flex-row-reverse')}>
          <button
            type='button'
            id='btnCancel'
            title='Cancel'
            onClick={handleCancel}
            className={clsx(
              'btn btn-sm',
              onCancelBtn && onCancelBtn.className
                ? onCancelBtn.className
                : 'btn btn-sm explore-btn-outline'
            )}
          >
            {onCancelBtn && onCancelBtn.title ? onCancelBtn.title : 'No'}
          </button>
          <Button
            id='btnOk'
            title={onOkBtn && onOkBtn.title ? onOkBtn.title : 'Yes'}
            isSubmitting={isSubmitting}
            onClick={handleOK}
            className={clsx(
              'btn btn-sm',
              onOkBtn && onOkBtn.className ? onOkBtn.className : ' btn-primary'
            )}
          />
        </div>
      </div>
    </Modal>
  ) : null
}

export default Prompt
